import { SessionBaseComponent } from '../../../../shared/components/session.base.component';
import { AfterViewInit, Component, Injector, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { isNullOrEmpty } from 'src/app/core/utils/common-functions';
import { DropdownOptionsService } from 'src/app/core/services/dropdown-options.service';
import { FacilityService } from 'src/app/core/services/facility.service';
import { WarehousingCreationService } from '../../services/warehousing-creation.service';
import { CommonDataService } from 'src/app/core/services/common-data.service';
import { PermissionConstants } from 'src/app/core/constants/permission-constants.constant';
import { LaasOption } from 'src/app/core/models/laas-option';
import { FacilityOptions } from 'src/app/core/models/options/facility-options';
import { noFullWidthValidator } from 'src/app/core/utils/validation-functions';

@Component({
  selector: 'laas-warehousing-creation',
  templateUrl: './warehousing-creation.component.html',
  styleUrls: ['./warehousing-creation.component.scss']
})
export class WarehousingCreationComponent extends SessionBaseComponent implements OnInit, AfterViewInit {

  readonly viewPermissionCode = PermissionConstants.ViewWarehousingCreation;
  readonly ExpressTermEditPermissionCode: PermissionConstants = PermissionConstants.EditWarehousingFormExpressTerm;
  currentLang: string = this.laasSetting.language;

  isLoading: boolean = false;
  createForm: FormGroup;
  bookingForwarderOptions: any[] = [];
  billCorpOptions: any[] = [];
  letterHeadOptions: any[] = [];
  shipTermOptions: LaasOption[] = [];
  billObjectTypeOptions: any[] = [];
  billObjectOptions: any[] = [];
  pickupLocationOptions: any[] = [];
  carTypeOptions: any[] = [];
  deliverySubOptions: any[] = [];
  deliveryOptions: any[] = [];
  allCityOptions: any[] = [];
  allAreaOptions: any[] = [];
  countryOptions: any[] = [];
  fromCityOptions: any[] = [];
  fromAreaOptions: any[] = [];
  toCityOptions: any[] = [];
  toAreaOptions: any[] = [];
  expressTermOptions: LaasOption[] = [];
  shipMethodOptions: any[] = [];
  yesNoOptions: any[] = [];
  shippingRemarkOptions: any[] = [];
  brandOptions: any[] = [];
  docTypeOptions: any[] = [];
  submitted: boolean = false;
  vendorSuggests: string[] = [];
  vendorOptions: any[] = [];
  urgentFlagOptions: any[] = [];

  defaultBillCorpOptions: any[] = [];

  isExpressTermEdit = false;

  constructor(
    injector: Injector,
    private facilityService: FacilityService,
    private warehousingCreationService: WarehousingCreationService,
    private commonDataService: CommonDataService,
    private dropdownOptionsService: DropdownOptionsService,
    private fb: FormBuilder
  ) {

    super(injector);

    this.createForm = this.fb.group({
      facility: '',
      shipper: [null, Validators.required],
      billObjectType: ["V", Validators.required],
      billObject: [null, Validators.required],
      vendorCustomer: [null, Validators.required],
      vendorCustomerName: null,
      deliveryType: ["IMPORT", Validators.required],
      orgId: [null, Validators.required],
      billCorp: [null, Validators.required],
      fromLocation:null,
      toLocation: [null], // 目的地不一定必填
      consolidationForwarder: [null],
      crossBoundryForwarder: [null],
      consolidationFromLocation: [null],
      consolidationToLocation: [null],

      expressTerm: null,
      // The portal remains the caller and keeps the existing default. The API
      // must preserve an omitted value instead of inventing G1 on its own.
      docType: "G1",
      shipTerm: ["CFR", Validators.required],
      whDt: null,
      expectedDt: null,
      hawbNo: [null, Validators.required],
      palletCnt: null,
      totalCartonCnt: [null, Validators.required],
      totalGrossWeight: null,
      totalChargeableWeight: [null, Validators.required],
      totalVolumeWeight: null,
      rfCaseCnt: null,
      totalQty: null,
      uom: null,
      uomQty: null,
      cartonCnt: null,
      bondedNo: null,
      bulkCargoNo: null,
      brand: null,
      isDropShipment: [0, Validators.required],
      isGenerateFee: [1, Validators.required],
      addressCode: [null, Validators.required],
      shippingRemark: null,
      urgentFlag: ['5', Validators.required],
      flightNo: null,
      flightDt: null,
      shippingMethod: null,
      mawbNo: null,
      docNo1: [null, [Validators.maxLength(2), noFullWidthValidator()]],
      docNo2: [null, [Validators.maxLength(2), noFullWidthValidator()]],
      docNo3: [null, [Validators.maxLength(2), noFullWidthValidator()]],
      docNo4: [null, [Validators.maxLength(4), noFullWidthValidator()]],
      docNo5: [null, [Validators.maxLength(5), noFullWidthValidator()]],
      deliverySubType: ['1', Validators.required],
      doNo: null,
      splitDept: null,
      createUser: ['', Validators.required],
      createDt: ['', Validators.required],
      updateUser: ['', Validators.required],
      updateDt: ['', Validators.required],
      quotationKey: null,
      whWmsFlag: 0,
      whStatus: "0",
      isPrint: 0,
      isManual: 1,
      employCode: null,
      deliveryAddress: null,
      isAbnormalNotify: [1, Validators.required],
    });

    // Keep these controls enabled so their required validators can provide
    // immediate feedback. The API remains responsible for final derivation
    // and validation of server-derived values.

    this.urgentFlagOptions = [];

    this.yesNoOptions = [];

  }

  get f() {
    return this.createForm.controls;
  }

  async ngOnInit(): Promise<void> {

    await super.ngOnInit();

    this.urgentFlagOptions = [
      { label: '非急單', value: '5' },
      { label: '急單', value: '1' }
    ];

    this.yesNoOptions = [
      { label: 'N', value: 0 },
      { label: 'Y', value: 1 }
    ];

    var defaultDate = new Date();

    this.createForm.controls.createUser.setValue(this.userProfile.userName);
    this.createForm.controls.createDt.setValue(defaultDate);
    this.createForm.controls.updateUser.setValue(this.userProfile.userName);
    this.createForm.controls.updateDt.setValue(defaultDate);
    this.createForm.controls.facility.setValue(this.laasSetting.facility);
    this.createForm.controls.employCode.setValue(this.userProfile.employCode);


    if (['CN_SH', 'SZ_RMB'].includes(this.laasSetting.facility)) {
      this.createForm.controls.deliveryType.setValue('DECLARATION');
      this.changeValidation();
    }


    this.dropdownOptionsService.getForwarderOptions()
      .subscribe({
        next: result => {
          this.bookingForwarderOptions = result;
        }
      });

    // 公司 orgId
    this.facilityService.getLetterOrgOptions(this.laasSetting.facility, "")
      .subscribe({
        next: (options: any[]) => {

          this.letterHeadOptions = [...options].map((x: any) => {
            return {
              label: `${x.legalEntityOUCode}-${x.legalEntityOUName} (${x.legalEntityReferenceCode})`,
              value: x.legalEntityOUCode,
              source: x
            };
          });

          this.defaultBillCorpOptions = [...options].filter(x => x.billOUCode !== null).map((x: any) => {
            return {
              label: `${x.billOUCode}-${x.billOUName}(${x.billReferenceCode})`,
              value: x.billOUCode,
            };
          });

        }
      });

    this.commonDataService.getCodeConverter(this.laasSetting.language, 'DropdownList', 'ShipTerm').subscribe({
      next: result => {
        this.shipTermOptions = [...result].map((x: any) => {
          return {
            label: `${x.codeKey}-${x.codeDesc}`,
            value: x.codeKey,
          };
        });
      }
    });

    this.dropdownOptionsService.getPickupLocationOptionByDefault(this.laasSetting.facility)
      .subscribe({
        next: (options: any[]) => {
          this.pickupLocationOptions = options.map(x => ({ label: x.optionDesc, value: x.optionCode }));
          if (this.pickupLocationOptions != null && this.pickupLocationOptions.length > 0) {
            this.createForm.controls.addressCode.setValue(this.pickupLocationOptions[0].value);
          }
        }
      });

    this.facilityService.getBillObjectTypeOptions().subscribe({
      next: result => {
        this.billObjectTypeOptions = [...result].map((x: any) => {
          return {
            label: `${x.optionCode}-${x.optionDesc}`,
            value: x.optionCode,
          };
        });
      }
    });

    this.facilityService.getBillObjectOptions(this.laasSetting.facility, this.createForm.value.billObjectType)
        .subscribe({
          next: result => {
            this.billObjectOptions = [...result].map((x: any) => {
              return {
                label: `${x.optionCode}-${x.optionDesc}`,
                value: x.optionCode,
              };
            });
          }
        });

    this.dropdownOptionsService.getCountryOptions()
      .subscribe({
        next: (options: any[]) => {
          this.countryOptions = options.map(x => ({ label: x.countryName, value: x.countryCode }));
        }
      });

    this.dropdownOptionsService.getCarTypeOptions()
      .subscribe({
        next: (options: any[]) => {
          this.carTypeOptions = options.map(x => ({ label: x.optionDesc, value: x.optionCode }));
        }
      });

    // 單據類型
    this.commonDataService.getCodeConverter(this.laasSetting.language, 'DropdownList', 'InboundDeliveryType')
      .subscribe({
        next: (options: any[]) => {
          this.deliveryOptions = options.map(x => ({ label: x.codeDesc, value: x.codeKey }));
        }
      });


    // 單據子類型
    this.commonDataService.getCodeConverter(this.laasSetting.language, 'DropdownList', 'InboundDeliverySubType')
      .subscribe({
        next: (options: any[]) => {
          this.deliverySubOptions = options.map(x => ({ label: x.codeDesc, value: x.codeKey }));
        }
      });


    //
    this.dropdownOptionsService.getAllCityOptions()
      .subscribe({
        next: (options: any[]) => {
          this.allCityOptions = options.map(x => ({ label: x.name, value: x.seqNo.toString(), country: x.country }));

          this.changeValidation();
        }
      });

    //
    this.dropdownOptionsService.getAllAreaOptionForHK()
      .subscribe({
        next: (options: any[]) => {
          this.allAreaOptions = options.map(x => ({ label: x.rfqAreaName, value: x.rfqAreaCode, citySeqNo: x.citySeqNo }));
        }
      });

    this.dropdownOptionsService.findFacilityOptionsByOptionType('ExpressTerm')
      .subscribe({
        next: (options: FacilityOptions[]) => {
          this.expressTermOptions = options.map(x => ({ label: x.optionDesc, value: x.optionCode }));
        }
      });

    // 運送方式
    this.facilityService.getShipMethodOptions().subscribe({
      next: result => {
        this.shipMethodOptions = [...result].map((x: any) => {
          return {
            label: `${x.optionCode}-${x.optionDesc}`,
            value: x.optionCode,
          };
        });
      }
    });

    // 船務不收貨原因
    this.commonDataService.getCodeConverter(this.laasSetting.language, 'DropdownList', 'ShippingRemark')
      .subscribe({
        next: (options: any[]) => {
          this.shippingRemarkOptions = options.map(x => ({ label: x.codeDesc, value: x.codeKey }));
        }
      });

    // 品牌
    this.dropdownOptionsService.getBrandOptions(1)
      .subscribe({
        next: (options: any[]) => {
          this.brandOptions = options.map(x => ({ label: x.brandName, value: x.brandName }));
        }
      });

    // 報關類別
    this.facilityService.getImportDocTypeOptions().subscribe({
      next: result => {
        this.docTypeOptions = [...result].map((x: any) => {
          return {
            label: `${x.optionCode}-${x.optionDesc}`,
            value: x.optionCode,
          };
        });
      }
    });

    this.isExpressTermEdit = this.permissionCodes.includes(this.ExpressTermEditPermissionCode);

  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.defaultCountyAndCity();
    }, 500);
  }

  // 預設目的國家,城市
  defaultCountyAndCity() {
    this.facilityService.getFacilityLocation(this.laasSetting.facility)
      .subscribe({
        next: (result: any[]) => {
          if (this.createForm.value.deliveryType !== 'DECLARATION') {
            this.createForm.patchValue({
              toLocation: {
                country: result[0].countryName,
                city: result[0].cityName,
                area: result[0].regionName
              }
            });
          }
        }
      });
  }

  changeBillObject(type: any) {
    const billObjectControl = this.createForm.controls.billObject;
    if (this.createForm.value.billObjectType === 'V') {
      billObjectControl.setValue(this.createForm.value.shipper, { emitEvent: false });
    } else {
      billObjectControl.setValue(null, { emitEvent: false });
    }

    this.facilityService.getBillObjectOptions(this.laasSetting.facility, this.createForm.value.billObjectType)
        .subscribe({
          next: result => {
            this.billObjectOptions = [...result].map((x: any) => {
              return {
                label: `${x.optionCode}-${x.optionDesc}`,
                value: x.optionCode,
              };
            });
          }
        });
  }


  checkBillObjectType(): boolean {
    return this.createForm.value.billObjectType == "V" ? true : false;
  }


  getBillCorpOptions() {

    this.facilityService.getLetterOrgOptions(this.laasSetting.facility, this.createForm.value.orgId)
      .subscribe({
        next: (options: any[]) => {

          let tempOption = [...options].map((x: any) => {
            return {
              label: `${x.billOUCode}-${x.billOUName} (${x.billReferenceCode})`,
              value: x.billOUCode,
            };
          });

          if (isNullOrEmpty(tempOption[0].value)) {
            this.billCorpOptions = this.defaultBillCorpOptions;
          } else {
            this.billCorpOptions = tempOption;
          }

          this.createForm.controls['billCorp'].setValue(this.billCorpOptions[0].value, { emitEvent: false });

        }
      });

  }

  getVendorOptions(event: any): void {
    const key: string = event.query;
    if (key != null && key.length > 1) {
      this.dropdownOptionsService.getVendorOptions(key).subscribe({
        next: (options: any[]) => {
          this.vendorSuggests = options.map(x => x.optionDesc);
          this.vendorOptions = options.map(x => {
            return {label: x.optionDesc, value: x.optionCode };
          });
        }
      });
    }
  }
  createClick() {
  console.log("createForm:", this.createForm.value);
  this.isLoading = true;

  // 供應商
  if (!isNullOrEmpty(this.createForm.value.vendorCustomer)) {
    let vendorTmp = this.createForm.value.vendorCustomer;
    let vendorTmpArray = this.vendorOptions.filter(x => {
      return x.label === vendorTmp;
    });

    if (vendorTmpArray.length > 0) {
      let temp = vendorTmpArray[0].label;
      let label = temp.substring(temp.lastIndexOf('-') + 2, temp.length);
      this.createForm.controls.vendorCustomerName.setValue(label);
      this.createForm.controls.vendorCustomer.setValue(vendorTmpArray[0].value);
    } else {
      this.createForm.controls.vendorCustomerName.setValue(this.createForm.value.vendorCustomer);
    }
  }

  this.submitted = true;
  if (this.createForm.invalid) {
    // 列出所有未填的必填欄位名稱，與 Excel 匯入錯誤提示格式一致
    // 1. FormGroup 上有掛 Validators.required 的欄位
    const fieldLabelMap: Record<string, string> = {
      shipper:               this.translateService.instant('ReceiptFormHeaderDetails.Forwarder'),
      billObjectType:        this.translateService.instant('ReceiptFormHeaderDetails.PayeeType'),
      vendorCustomer:        this.translateService.instant('ReceiptFormHeaderDetails.Supplier'),
      deliveryType:          this.translateService.instant('ReceiptFormHeaderDetails.DeliveryType'),
      orgId:                 this.translateService.instant('ReceiptFormHeaderDetails.OrgId'),
      shipTerm:              this.translateService.instant('ReceiptFormHeaderDetails.TradeTerm'),
      hawbNo:                this.translateService.instant('ReceiptFormHeaderDetails.HAWB'),
      totalCartonCnt:        this.translateService.instant('ReceiptFormHeaderDetails.TotalCartonCnt'),
      totalChargeableWeight: this.translateService.instant('ReceiptFormHeaderDetails.TotalChargeableWeight'),
      isDropShipment:        this.translateService.instant('ReceiptFormHeaderDetails.DropShipment'),
      isGenerateFee:         this.translateService.instant('ReceiptFormHeaderDetails.GenerateExpenses'),
      addressCode:           this.translateService.instant('ReceiptFormHeaderDetails.PickUpAddress'),
      urgentFlag:            this.translateService.instant('ReceiptFormHeaderDetails.IsUrgent'),
      deliverySubType:       this.translateService.instant('ReceiptFormHeaderDetails.DocumentSubType'),
      isAbnormalNotify:      this.translateService.instant('ReceiptFormHeaderDetails.FeiliksNotifyFlag'),
    };
    const missingFields: string[] = Object.entries(fieldLabelMap)
      .filter(([key]) => this.createForm.controls[key]?.invalid)
      .map(([, label]) => label);

    // 2. laas-location-cascade-dropdown 的 validate() 回傳個別 error key（countryRequired / cityRequired）
    const fromLocationErrors = this.createForm.controls['fromLocation']?.errors;
    if (fromLocationErrors?.['countryRequired']) {
      missingFields.push(this.translateService.instant('ReceiptFormHeaderDetails.OriginCountry'));
    }
    if (fromLocationErrors?.['cityRequired']) {
      missingFields.push(this.translateService.instant('ReceiptFormHeaderDetails.OriginCity'));
    }

    const msg = missingFields.length > 0
      ? this.translateService.instant('ReceiptFormQuery.Alert.CheckRequired') + ':\n' + missingFields.join('\n')
      : this.translateService.instant('ReceiptFormQuery.Alert.CheckRequired');
    this.toastService.warn(msg);
    this.loader.hide();
    return;
  }

  // 文件編號處理
  var docNo1 = isNullOrEmpty(this.createForm.value.docNo1) ? "" : this.createForm.value.docNo1;
  var docNo2 = isNullOrEmpty(this.createForm.value.docNo2) ? "" : this.createForm.value.docNo2;
  var docNo3 = isNullOrEmpty(this.createForm.value.docNo3) ? "" : this.createForm.value.docNo3;
  var docNo4 = isNullOrEmpty(this.createForm.value.docNo4) ? "" : this.createForm.value.docNo4;
  var docNo5 = isNullOrEmpty(this.createForm.value.docNo5) ? "" : this.createForm.value.docNo5;
  var impDocNo = docNo1 + "/" + docNo2 + "/" + docNo3 + "/" + docNo4 + "/" + docNo5;

  // 轉換 location 資料為 API 格式
  const formData = this.convertLocationDataForApi(this.createForm.value);
  formData.impDocNo = impDocNo;

  if (!isNullOrEmpty(this.createForm.controls.hawbNo.value)) {
    if (this.createForm.controls.hawbNo.value.length > 50) {
      this.toastService.error(this.translateService.instant('ReceiptFormHeaderDetailsEdit.HAWBNoWordCountExceeds'));
      return;
    }
  }

  let tempArray = [];
  tempArray.push(formData);

  this.warehousingCreationService.addWarehousing(tempArray)
    .subscribe({
      next: result => {
        if (result != null) {
          let whNo = result[0];
          this.toastService.success(this.translateService.instant('ReceiptFormQuery.Success.AddSuccess') + ' 入倉編號:' + whNo);
          this.routeStateService.navigateTo('/TransportOperation/WarehousingSearch', { whNoList: [whNo], errMsgs: [] });
        }
        this.loader.hide();
      },
      error: (err: any) => {
        this.toastErrorMessage(err.error);
      }
    });
  }

  // 轉換 location 資料為 API 格式
  private convertLocationDataForApi(formValue: any): any {
    const apiData = { ...formValue };

    // 轉換起運地
    if (formValue.fromLocation) {
      apiData.fromCountry = formValue.fromLocation.country;
      apiData.fromCity = formValue.fromLocation.city;
      apiData.fromArea = formValue.fromLocation.area;
      delete apiData.fromLocation;
    }

    // 轉換目的地
    if (formValue.toLocation) {
      apiData.toCountry = formValue.toLocation.country;
      apiData.toCity = formValue.toLocation.city;
      apiData.toArea = formValue.toLocation.area;
      delete apiData.toLocation;
    }

    // 轉換起運地
    if (formValue.consolidationFromLocation) {
      apiData.consolidationFromCountry = formValue.consolidationFromLocation.country;
      apiData.consolidationFromCity = formValue.consolidationFromLocation.city;
      apiData.consolidationFromArea = formValue.consolidationFromLocation.area;
      delete apiData.consolidationFromLocation;
    }

    // 轉換目的地
    if (formValue.consolidationToLocation) {
      apiData.consolidationToCountry = formValue.consolidationToLocation.country;
      apiData.consolidationToCity = formValue.consolidationToLocation.city;
      apiData.consolidationToArea = formValue.consolidationToLocation.area;
      delete apiData.consolidationToLocation;
    }

    return apiData;
  }



  //檢查 location 是否有錯誤的輔助方法
  hasLocationError(locationName: 'fromLocation' | 'toLocation' | 'consolidationFromLocation' | 'consolidationToLocation'): boolean {
    const control = this.createForm.get(locationName);
    return !!(control && control.errors && (control.touched || this.submitted));
  }

  //取得 location 錯誤訊息
  getLocationErrorMessage(locationName: 'fromLocation' | 'toLocation'): string {
    const control = this.createForm.get(locationName);
    if (control?.errors) {
      if (control.errors['required']) {
        return this.translateService.instant('Common.Button.Required');
      }
      if (control.errors['locationRequired']) {
        return control.errors['message'] || this.translateService.instant('Common.Button.Required');
      }
    }
    return '';
  }

  importClick() {
    this.routeStateService.navigateTo('/TransportOperation/WarehousingUpload', null);
  }

  changeValidation() {
  if (this.createForm.value.deliveryType == 'DECLARATION') {
    this.createForm.controls.vendorCustomer.clearValidators();
    this.createForm.controls.totalCartonCnt.clearValidators();
    this.createForm.controls.hawbNo.clearValidators();
    this.createForm.controls.totalChargeableWeight.clearValidators();
    this.createForm.controls.shipTerm.clearValidators();

    this.createForm.controls.shipTerm.setValue('ALL');

    this.createForm.patchValue({
      fromLocation: {
        country: 'CN',
        city: '45'
      },
      toLocation: {
        country: 'CN',
        city: '357'
      }
    });

    } else if (this.createForm.value.deliveryType == 'LOCAL') {
      this.createForm.controls.vendorCustomer.setValidators(Validators.required);
      this.createForm.controls.totalCartonCnt.setValidators(Validators.required);
      this.createForm.controls.hawbNo.setValidators(Validators.required);
      this.createForm.controls.totalChargeableWeight.setValidators(Validators.required);
      this.createForm.controls.shipTerm.clearValidators();

      this.createForm.controls.shipTerm.setValue(null);
      this.defaultCountyAndCity();

    } else {
      this.createForm.controls.vendorCustomer.setValidators(Validators.required);
      this.createForm.controls.totalCartonCnt.setValidators(Validators.required);
      this.createForm.controls.hawbNo.setValidators(Validators.required);
      this.createForm.controls.totalChargeableWeight.setValidators(Validators.required);
      this.createForm.controls.shipTerm.setValidators(Validators.required);

      this.defaultCountyAndCity();

    }

    // 更新 location 欄位的驗證狀態
    this.createForm.controls.fromLocation.updateValueAndValidity();
    this.createForm.controls.toLocation.updateValueAndValidity();
    this.createForm.controls.consolidationFromLocation.updateValueAndValidity();
    this.createForm.controls.consolidationToLocation.updateValueAndValidity();
    this.createForm.controls.vendorCustomer.updateValueAndValidity();
    this.createForm.controls.totalCartonCnt.updateValueAndValidity();
    this.createForm.controls.hawbNo.updateValueAndValidity();
    this.createForm.controls.totalChargeableWeight.updateValueAndValidity();
    this.createForm.controls.shipTerm.updateValueAndValidity();
  }

  updateValidity(control: AbstractControl): boolean{
    return control.validator !== null;
  }
}
